import React, {FC,} from "react";
import {ConfirmIconButton, DeleteIconButton, EditIconButton} from "./IconButtons";
import RightAlignedColumn from "./RightAlignedColumn";

interface Props {
    confirm: boolean;
    onEdit: VoidFunction;
    onDelete: VoidFunction;
    onConfirm: VoidFunction;
    onReject: VoidFunction;
}

const EditDeleteConfirm: FC<Props> = (props) => {
    return (
        <RightAlignedColumn width={"100px"}>

            {
                props.confirm ?
                    <ConfirmIconButton small
                                       onClick={props.onConfirm}
                                       onReject={props.onReject}/>
                    : <>
                        <EditIconButton onClick={props.onEdit} small/>&nbsp;
                        <DeleteIconButton onClick={props.onDelete} small/>
                    </>
            }
        </RightAlignedColumn>
    )
}

export default EditDeleteConfirm;
